import { FC, useRef } from 'react';
import styled from 'styled-components';

import { Markdown } from '#/components/Markdown';
import { FormFactors } from '#/service/constants';
import { remify } from '#/service/utils';
import { tb } from '#/store/translation/translation.store';

type FormFactorProp = {
  formFactor: string;
};

const Container = styled.div<FormFactorProp>`
  display: flex;
  flex-direction: column;
  width: ${({ formFactor }) =>
    formFactor === FormFactors.DESKTOP ? '55vw' : '100vw'};
  max-height: ${({ formFactor }) =>
    formFactor === FormFactors.DESKTOP
      ? '55vh'
      : `calc(100svh - ${remify(79)})`};
`;

const Heading = styled.h2<FormFactorProp>`
  font: ${({ formFactor }) =>
    formFactor === FormFactors.DESKTOP
      ? `var(--fontStyleHeadline)`
      : `var(--fontStyleTitle)`};
  margin: 0;
  padding: ${({ formFactor }) =>
    formFactor === FormFactors.DESKTOP
      ? `0 0 ${remify(20)}`
      : `${remify(16)} 0`};
`;

const MarkdownContainer = styled.div`
  overflow-y: auto;
  margin: 0 0 ${remify(35)};
  overscroll-behavior: contain;
`;

interface Props {
  formFactor: FormFactors;
  termsBody: string;
}

export const Terms: FC<Props> = ({ termsBody, formFactor }) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <Container data-testid="termsContainer" formFactor={formFactor}>
      <Heading formFactor={formFactor} id="modal-title">
        {tb('prompt.notification.terms.title')}
      </Heading>
      <MarkdownContainer ref={ref}>
        <Markdown>{termsBody}</Markdown>
      </MarkdownContainer>
    </Container>
  );
};
